// ARQUIVO GERADO por set-env.js — não editar manualmente nem versionar.
// Configure os valores em .env (ver .env.exemplo) ou nas variáveis do CI.
export const environment = {
  producao: true,
  apiUrl: 'https://reurb-api.onrender.com/v1',
  googleMaps: {
    chaveApi: 'AIzaSyBuBXTOuCtrLyl1DcsXsYlSlPCRhdbyzDA',
    mapId: 'DEMO_MAP_ID'
  }
};
